import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';

/**
 * Generated class for the FormatDriverTypePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatUserTags',
})
export class FormatUserTagsPipe implements PipeTransform {
  /**
   * Takes a job's drivertype value and displays in a human-readable format
   */
  transform(value: string, user) {
    let userTags = {
      cdlHolder: 'CDL Holder',
      ownerOperator: 'Owner Operator',
      ownAuthority: 'Own Authority',
      moderator: 'Moderator',
    };

    if (
      _.get(user, 'dates.created') &&
      new Date(user.dates.created) > moment().subtract(7, 'days').toDate()
    ) {
      return 'New User';
    }

    return userTags[value] || null;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-userTags/format-userTags.ts